import { useState, useEffect } from 'react';
import axios from 'utils/axios';

const GetSubmissionTypeService = () => {
    const [listData, setListData] = useState([]);

    const getData = async (url, action) => {
        await axios.get(url).then((response) => {
            action(response.data);
        });
    };

    useEffect(() => {
        getData('api/prv/submission-types', setListData);
    }, []);

    return { listData };
};

export default GetSubmissionTypeService;
